import React from 'react'
import DataTable from '../../Components/Molecules/Table/DataTable'
import { users_list } from "../../Enums/api_constunts"
export default function MyProfile() {

  const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Name", field: "first_name", minWidth:150},
    { headerName: "Email", field: "email",minWidth:150 },
    { headerName: "Phone", field: "mobile_no",minWidth:150 },
    { headerName: "Status", field: "status_details.name",minWidth:150 },
    //{ headerName: "Role", field: "role_details.name",maxWidth:100 },
    { headerName: "Actions", field: "actions",maxWidth:10000 },
  ];

  const filterData ={}
  
  return (
    <div>
      
        <div class="mt-2">
            <h2>Profile Data</h2>
        </div>
    </div>
  )
}
